import { ScanStand } from "./salon/ScanStand.tsx";
import { lazy, Suspense } from "react";
import { Redirection, Router, useRoute } from "./lib/router.tsx";
import { AppProvider, useApp } from "./app/state.tsx";
import { accueilRole } from "./app/config.ts";
import { Shell } from "./app/Shell.tsx";
import { Login } from "./screens/Login.tsx";
import { ExposantDashboard } from "./screens/ExposantDashboard.tsx";
import { ExposantTunnel } from "./screens/ExposantTunnel.tsx";
import { AdminRoute } from "./admin/AdminRoute.tsx";
import { FrontRoute } from "./front/FrontRoute.tsx";
import { PublicRoute } from "./public/PublicRoute.tsx";

const SalonDirect = lazy(() => import("./salon/SalonDirect.tsx").then((m) => ({ default: m.SalonDirect })));
const EcranSalon = lazy(() => import("./salon/SalonDemo.tsx").then((m) => ({ default: m.SalonDemo })));

export function App(): React.ReactElement {
  return (
    <Router>
      <AppProvider>
        <Vue />
      </AppProvider>
    </Router>
  );
}

function Vue(): React.ReactElement {
  const { chemin } = useRoute();
  const app = useApp();

  if (chemin === "/salon/ecran") return <Suspense fallback={<p role="status">Connexion au salon…</p>}><SalonDirect /></Suspense>;
  if (chemin === "/salon/demo") return <Suspense fallback={<p role="status">Chargement du salon 3D…</p>}><EcranSalon /></Suspense>;

  if (chemin === "/public" || chemin === "/public/") return <Redirection vers="/login" />;

  // L'espace public (pré-inscriptions) est accessible sans compte.
  if (chemin === "/public" || chemin.startsWith("/public/")) return <PublicRoute chemin={chemin} />;

  // Tant qu'aucune session n'est ouverte, l'application est la page de connexion.
  if (!app.connecte) return <Login />;

  if (chemin.startsWith("/salon/scan/")) return <ScanStand key={chemin} />;

  const effectif = (chemin === "/" || chemin === "/login") ? accueilRole(app.role) : chemin;
  return <Shell>{resoudre(effectif)}</Shell>;
}

function resoudre(chemin: string): React.ReactElement {
  if (chemin === "/admin" || chemin.startsWith("/admin/")) return <AdminRoute chemin={chemin} />;
  switch (chemin) {
    case "/exposant":
      return <ExposantDashboard />;
    case "/exposant/reservation":
      return <ExposantTunnel />;
    default:
      return <FrontRoute chemin={chemin} />;
  }
}
